export const enumRoles = { ADMIN: 1, MANAGER: 2, FINANCE: 3, SUPPORT: 4, USER: 5, BAN: 99 }

const enumPermissionActions = {
  LIST: 'list',
  GET: 'get',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  VALIDATE: 'validate',
  BALANCE: 'balance',
  REPORT: 'report',
  REPLY: 'reply',
  STATUS: 'status',
  OVERVIEW: 'overview',
  REALTIME: 'real.time',
  REQUEST: 'request',
  QUEUE_EMAIL: 'queue.email',
  SUM_REQUEST_BY_DATE: 'sum-request-by-date',
  KEYWORDS_ANALYTICS: 'keywords-analytics'
}
const EPA = enumPermissionActions

export const enumPermissionModules = {
  ADMIN_DASHBOARD: 'admin.dashboard',
  ADMIN_STATS: 'admin.stats',
  ADMIN_BI: 'admin.businessintelligence',
  ADMIN_LOGS: 'admin.logs',
  ADMIN_USERS: 'admin.users',
  ADMIN_PERMISSION: 'admin.permission',
  ADMIN_PARTNERS: 'admin.partners',
  ADMIN_DOMAIN: 'admin.domain',
  ADMIN_FEED: 'admin.feed',
  ADMIN_FEED_FLOW: 'admin.feed.flow',
  ADMIN_CAMPAIGNS: 'admin.campaigns',
  ADMIN_CAMPAIGNS_AUDIENCE: 'admin.campaigns.audience',
  ADMIN_CAMPAIGNS_RULES: 'admin.campaigns.rules',
  ADMIN_PAYMENT: 'admin.payment',
  ADMIN_NEWSLETTER: 'admin.newsletter',
  ADMIN_NEWSLETTER_ASSETS: 'admin.newsletter.assets',
  ADMIN_NEWSLETTER_TEMPLATE: 'admin.newsletter.templates',
  ADMIN_LOGIN_HISTORY: 'admin.login-history',
  ADMIN_PROFILE: 'admin.profile',
  ADMIN_COUNTRY: 'admin.country',
  SETTINGS: 'settings',
  ADMIN_TICKETS: 'admin.tickets',
}
const EPM = enumPermissionModules

export const enumPermissions = {
  // Admin - Dashboard
  ADMIN_DASHBOARD_OVERVIEW: `${EPM.ADMIN_DASHBOARD}/${EPA.OVERVIEW}`,
  ADMIN_DASHBOARD_REALTIME: `${EPM.ADMIN_DASHBOARD}/${EPA.REALTIME}`,
  // Admin - Stats
  ADMIN_STATS_BALANCE: `${EPM.ADMIN_STATS}/${EPA.BALANCE}`,
  ADMIN_STATS_REPORT: `${EPM.ADMIN_STATS}/${EPA.REPORT}`,
  // Admin - BI
  ADMIN_BI_SUM_REQUEST_BY_DATE: `${EPM.ADMIN_BI}/${EPA.SUM_REQUEST_BY_DATE}`,
  ADMIN_BI_KEYWORDS_ANALYTICS: `${EPM.ADMIN_BI}/${EPA.KEYWORDS_ANALYTICS}`,
  // Admin - Stats
  ADMIN_LOGS_REPORT: `${EPM.ADMIN_LOGS}/${EPA.REPORT}`,
  ADMIN_LOGS_REQUEST: `${EPM.ADMIN_LOGS}/${EPA.REQUEST}`,
  ADMIN_LOGS_QUEUE_EMAIL: `${EPM.ADMIN_LOGS}/${EPA.QUEUE_EMAIL}`,
  // Admin - Users
  ADMIN_USERS_LIST: `${EPM.ADMIN_USERS}/${EPA.LIST}`,
  ADMIN_USERS_GET: `${EPM.ADMIN_USERS}/${EPA.GET}`,
  ADMIN_USERS_CREATE: `${EPM.ADMIN_USERS}/${EPA.CREATE}`,
  ADMIN_USERS_UPDATE: `${EPM.ADMIN_USERS}/${EPA.UPDATE}`,
  ADMIN_USERS_DELETE: `${EPM.ADMIN_USERS}/${EPA.DELETE}`,
  ADMIN_USERS_VALIDATE: `${EPM.ADMIN_USERS}/${EPA.VALIDATE}`,
  // Admin - Permissions
  ADMIN_PERMISSION_GET: `${EPM.ADMIN_PERMISSION}/${EPA.GET}`,
  ADMIN_PERMISSION_UPDATE: `${EPM.ADMIN_PERMISSION}/${EPA.UPDATE}`,
  // Admin - Partners
  ADMIN_PARTNERS_LIST: `${EPM.ADMIN_PARTNERS}/${EPA.LIST}`,
  ADMIN_PARTNERS_GET: `${EPM.ADMIN_PARTNERS}/${EPA.GET}`,
  ADMIN_PARTNERS_CREATE: `${EPM.ADMIN_PARTNERS}/${EPA.CREATE}`,
  ADMIN_PARTNERS_UPDATE: `${EPM.ADMIN_PARTNERS}/${EPA.UPDATE}`,
  ADMIN_PARTNERS_DELETE: `${EPM.ADMIN_PARTNERS}/${EPA.DELETE}`,
  // Admin - Domains
  ADMIN_DOMAIN_LIST: `${EPM.ADMIN_DOMAIN}/${EPA.LIST}`,
  ADMIN_DOMAIN_GET: `${EPM.ADMIN_DOMAIN}/${EPA.GET}`,
  ADMIN_DOMAIN_CREATE: `${EPM.ADMIN_DOMAIN}/${EPA.CREATE}`,
  ADMIN_DOMAIN_UPDATE: `${EPM.ADMIN_DOMAIN}/${EPA.UPDATE}`,
  ADMIN_DOMAIN_DELETE: `${EPM.ADMIN_DOMAIN}/${EPA.DELETE}`,
  // Admin - Feed
  ADMIN_FEED_LIST: `${EPM.ADMIN_FEED}/${EPA.LIST}`,
  ADMIN_FEED_GET: `${EPM.ADMIN_FEED}/${EPA.GET}`,
  ADMIN_FEED_CREATE: `${EPM.ADMIN_FEED}/${EPA.CREATE}`,
  ADMIN_FEED_UPDATE: `${EPM.ADMIN_FEED}/${EPA.UPDATE}`,
  ADMIN_FEED_DELETE: `${EPM.ADMIN_FEED}/${EPA.DELETE}`,
  // Admin - Feed Flow
  ADMIN_FEED_FLOW_LIST: `${EPM.ADMIN_FEED_FLOW}/${EPA.LIST}`,
  ADMIN_FEED_FLOW_GET: `${EPM.ADMIN_FEED_FLOW}/${EPA.GET}`,
  ADMIN_FEED_FLOW_CREATE: `${EPM.ADMIN_FEED_FLOW}/${EPA.CREATE}`,
  ADMIN_FEED_FLOW_UPDATE: `${EPM.ADMIN_FEED_FLOW}/${EPA.UPDATE}`,
  ADMIN_FEED_FLOW_DELETE: `${EPM.ADMIN_FEED_FLOW}/${EPA.DELETE}`,
  // Admin - Campaigns
  ADMIN_CAMPAIGNS_LIST: `${EPM.ADMIN_CAMPAIGNS}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_GET: `${EPM.ADMIN_CAMPAIGNS}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_CREATE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.CREATE}`,
  ADMIN_CAMPAIGNS_UPDATE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_DELETE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.DELETE}`,
  // Admin - Campaigns Audience
  ADMIN_CAMPAIGNS_AUDIENCE_GET: `${EPM.ADMIN_CAMPAIGNS_AUDIENCE}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_AUDIENCE_UPDATE: `${EPM.ADMIN_CAMPAIGNS_AUDIENCE}/${EPA.UPDATE}`,
  // Admin - Campaigns Rules
  ADMIN_CAMPAIGNS_RULES_LIST: `${EPM.ADMIN_CAMPAIGNS_RULES}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_RULES_GET: `${EPM.ADMIN_CAMPAIGNS_RULES}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_RULES_CREATE: `${EPM.ADMIN_CAMPAIGNS_RULES}/${EPA.CREATE}`,
  ADMIN_CAMPAIGNS_RULES_UPDATE: `${EPM.ADMIN_CAMPAIGNS_RULES}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_RULES_DELETE: `${EPM.ADMIN_CAMPAIGNS_RULES}/${EPA.DELETE}`,
  // Admin - Payments
  ADMIN_PAYMENT_LIST: `${EPM.ADMIN_PAYMENT}/${EPA.LIST}`,
  ADMIN_PAYMENT_GET: `${EPM.ADMIN_PAYMENT}/${EPA.GET}`,
  ADMIN_PAYMENT_CREATE: `${EPM.ADMIN_PAYMENT}/${EPA.CREATE}`,
  ADMIN_PAYMENT_UPDATE: `${EPM.ADMIN_PAYMENT}/${EPA.UPDATE}`,
  ADMIN_PAYMENT_DELETE: `${EPM.ADMIN_PAYMENT}/${EPA.DELETE}`,
  // Admin - Newsletter List
  ADMIN_NEWSLETTER_LIST: `${EPM.ADMIN_NEWSLETTER}/${EPA.LIST}`,
  ADMIN_NEWSLETTER_GET: `${EPM.ADMIN_NEWSLETTER}/${EPA.GET}`,
  ADMIN_NEWSLETTER_CREATE: `${EPM.ADMIN_NEWSLETTER}/${EPA.CREATE}`,
  ADMIN_NEWSLETTER_UPDATE: `${EPM.ADMIN_NEWSLETTER}/${EPA.UPDATE}`,
  ADMIN_NEWSLETTER_DELETE: `${EPM.ADMIN_NEWSLETTER}/${EPA.DELETE}`,
  // Admin - Newsletter Assets
  ADMIN_NEWSLETTER_ASSETS_LIST: `${EPM.ADMIN_NEWSLETTER_ASSETS}/${EPA.LIST}`,
  ADMIN_NEWSLETTER_ASSETS_GET: `${EPM.ADMIN_NEWSLETTER_ASSETS}/${EPA.GET}`,
  ADMIN_NEWSLETTER_ASSETS_CREATE: `${EPM.ADMIN_NEWSLETTER_ASSETS}/${EPA.CREATE}`,
  ADMIN_NEWSLETTER_ASSETS_UPDATE: `${EPM.ADMIN_NEWSLETTER_ASSETS}/${EPA.UPDATE}`,
  ADMIN_NEWSLETTER_ASSETS_DELETE: `${EPM.ADMIN_NEWSLETTER_ASSETS}/${EPA.DELETE}`,
  // Admin - Newsletter Template
  ADMIN_NEWSLETTER_TEMPLATE_LIST: `${EPM.ADMIN_NEWSLETTER_TEMPLATE}/${EPA.LIST}`,
  ADMIN_NEWSLETTER_TEMPLATE_GET: `${EPM.ADMIN_NEWSLETTER_TEMPLATE}/${EPA.GET}`,
  ADMIN_NEWSLETTER_TEMPLATE_CREATE: `${EPM.ADMIN_NEWSLETTER_TEMPLATE}/${EPA.CREATE}`,
  ADMIN_NEWSLETTER_TEMPLATE_UPDATE: `${EPM.ADMIN_NEWSLETTER_TEMPLATE}/${EPA.UPDATE}`,
  ADMIN_NEWSLETTER_TEMPLATE_DELETE: `${EPM.ADMIN_NEWSLETTER_TEMPLATE}/${EPA.DELETE}`,
  // Admin - Login history
  ADMIN_LOGIN_HISTORY_LIST: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.LIST}`,
  // Admin - Profile
  ADMIN_PROFILE_GET: `${EPM.ADMIN_PROFILE}/${EPA.GET}`,
  ADMIN_PROFILE_UPDATE: `${EPM.ADMIN_PROFILE}/${EPA.UPDATE}`,
  // Admin - Country
  ADMIN_COUNTRY_LIST: `${EPM.ADMIN_COUNTRY}/${EPA.LIST}`,
  // Settings
  SETTINGS_GET: `${EPM.SETTINGS}/${EPA.GET}`,
  SETTINGS_UPDATE: `${EPM.SETTINGS}/${EPA.UPDATE}`,
  // Admin - Tickets
  ADMIN_TICKETS_LIST: `${EPM.ADMIN_TICKETS}/${EPA.LIST}`,
  ADMIN_TICKETS_GET: `${EPM.ADMIN_TICKETS}/${EPA.GET}`,
  ADMIN_TICKETS_DELETE: `${EPM.ADMIN_TICKETS}/${EPA.DELETE}`,
  ADMIN_TICKETS_REPLY: `${EPM.ADMIN_TICKETS}/${EPA.REPLY}`,
  ADMIN_TICKETS_STATUS: `${EPM.ADMIN_TICKETS}/${EPA.STATUS}`,
}
const EP = enumPermissions

export const constructedPermissionTree = {
  [EPM.ADMIN_DASHBOARD]: {
    original: [EPA.OVERVIEW, EPA.REALTIME],
    modified: [EP.ADMIN_DASHBOARD_OVERVIEW, EP.ADMIN_DASHBOARD_REALTIME]
  },
  [EPM.ADMIN_STATS]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_STATS_BALANCE, EP.ADMIN_STATS_REPORT]
  },
  [EPM.ADMIN_BI]: {
    original: [EPA.SUM_REQUEST_BY_DATE, EPA.KEYWORDS_ANALYTICS],
    modified: [EP.ADMIN_BI_SUM_REQUEST_BY_DATE, EP.ADMIN_BI_KEYWORDS_ANALYTICS]
  },
  [EPM.ADMIN_LOGS]: {
    original: [EPA.REPORT, EPA.REQUEST, EPA.QUEUE_EMAIL],
    modified: [EP.ADMIN_LOGS_REPORT, EP.ADMIN_LOGS_REQUEST, EP.ADMIN_LOGS_QUEUE_EMAIL]
  },
  [EPM.ADMIN_USERS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE, EPA.VALIDATE],
    modified: [EP.ADMIN_USERS_LIST, EP.ADMIN_USERS_GET, EP.ADMIN_USERS_CREATE, EP.ADMIN_USERS_UPDATE, EP.ADMIN_USERS_DELETE, EP.ADMIN_USERS_VALIDATE]
  },
  [EPM.ADMIN_PERMISSION]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PERMISSION_GET, EP.ADMIN_PERMISSION_UPDATE]
  },
  [EPM.ADMIN_PARTNERS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_PARTNERS_LIST, EP.ADMIN_PARTNERS_GET, EP.ADMIN_PARTNERS_CREATE, EP.ADMIN_PARTNERS_UPDATE, EP.ADMIN_PARTNERS_DELETE]
  },
  [EPM.ADMIN_DOMAIN]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_DOMAIN_LIST, EP.ADMIN_DOMAIN_GET, EP.ADMIN_DOMAIN_CREATE, EP.ADMIN_DOMAIN_UPDATE, EP.ADMIN_DOMAIN_DELETE]
  },
  [EPM.ADMIN_FEED]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_FEED_LIST, EP.ADMIN_FEED_GET, EP.ADMIN_FEED_CREATE, EP.ADMIN_FEED_UPDATE, EP.ADMIN_FEED_DELETE]
  },
  [EPM.ADMIN_FEED_FLOW]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_FEED_FLOW_LIST, EP.ADMIN_FEED_FLOW_GET, EP.ADMIN_FEED_FLOW_CREATE, EP.ADMIN_FEED_FLOW_UPDATE, EP.ADMIN_FEED_FLOW_DELETE]
  },
  [EPM.ADMIN_CAMPAIGNS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_CAMPAIGNS_LIST, EP.ADMIN_CAMPAIGNS_GET, EP.ADMIN_CAMPAIGNS_CREATE, EP.ADMIN_CAMPAIGNS_UPDATE, EP.ADMIN_CAMPAIGNS_DELETE]
  },
  [EPM.ADMIN_CAMPAIGNS_AUDIENCE]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_CAMPAIGNS_AUDIENCE_GET, EP.ADMIN_CAMPAIGNS_AUDIENCE_UPDATE]
  },
  [EPM.ADMIN_CAMPAIGNS_RULES]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_CAMPAIGNS_RULES_LIST, EP.ADMIN_CAMPAIGNS_RULES_GET, EP.ADMIN_CAMPAIGNS_RULES_CREATE, EP.ADMIN_CAMPAIGNS_RULES_UPDATE, EP.ADMIN_CAMPAIGNS_RULES_DELETE]
  },
  [EPM.ADMIN_PAYMENT]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_PAYMENT_LIST, EP.ADMIN_PAYMENT_GET, EP.ADMIN_PAYMENT_CREATE, EP.ADMIN_PAYMENT_UPDATE, EP.ADMIN_PAYMENT_DELETE]
  },
  [EPM.ADMIN_NEWSLETTER]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_NEWSLETTER_LIST, EP.ADMIN_NEWSLETTER_GET, EP.ADMIN_NEWSLETTER_CREATE, EP.ADMIN_NEWSLETTER_UPDATE, EP.ADMIN_NEWSLETTER_DELETE]
  },
  [EPM.ADMIN_NEWSLETTER_ASSETS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_NEWSLETTER_ASSETS_LIST, EP.ADMIN_NEWSLETTER_ASSETS_GET, EP.ADMIN_NEWSLETTER_ASSETS_CREATE, EP.ADMIN_NEWSLETTER_ASSETS_UPDATE, EP.ADMIN_NEWSLETTER_ASSETS_DELETE]
  },
  [EPM.ADMIN_NEWSLETTER_TEMPLATE]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_NEWSLETTER_TEMPLATE_LIST, EP.ADMIN_NEWSLETTER_TEMPLATE_GET, EP.ADMIN_NEWSLETTER_TEMPLATE_CREATE, EP.ADMIN_NEWSLETTER_TEMPLATE_UPDATE, EP.ADMIN_NEWSLETTER_TEMPLATE_DELETE]
  },
  [EPM.ADMIN_LOGIN_HISTORY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_LOGIN_HISTORY_LIST]
  },
  [EPM.ADMIN_PROFILE]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PROFILE_GET, EP.ADMIN_PROFILE_UPDATE]
  },
  [EPM.ADMIN_COUNTRY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_COUNTRY_LIST]
  },
  [EPM.SETTINGS]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.SETTINGS_GET, EP.SETTINGS_UPDATE]
  },
  [EPM.ADMIN_TICKETS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.REPLY, EPA.STATUS],
    modified: [EP.ADMIN_TICKETS_LIST, EP.ADMIN_TICKETS_GET, EP.ADMIN_TICKETS_DELETE, EP.ADMIN_TICKETS_REPLY, EP.ADMIN_TICKETS_STATUS]
  },
}
const CPT = constructedPermissionTree

export const adminModules = [
  EPM.ADMIN_DASHBOARD,
  EPM.ADMIN_STATS,
  EPM.ADMIN_BI,
  EPM.ADMIN_LOGS,
  EPM.ADMIN_USERS,
  EPM.ADMIN_PERMISSION,
  EPM.ADMIN_PARTNERS,
  EPM.ADMIN_DOMAIN,
  EPM.ADMIN_FEED,
  EPM.ADMIN_FEED_FLOW,
  EPM.ADMIN_CAMPAIGNS,
  EPM.ADMIN_CAMPAIGNS_AUDIENCE,
  EPM.ADMIN_CAMPAIGNS_RULES,
  EPM.ADMIN_PAYMENT,
  EPM.ADMIN_NEWSLETTER,
  EPM.ADMIN_NEWSLETTER_ASSETS,
  EPM.ADMIN_NEWSLETTER_TEMPLATE,
  EPM.ADMIN_LOGIN_HISTORY,
  EPM.ADMIN_PROFILE,
  EPM.ADMIN_COUNTRY,
  EPM.ADMIN_TICKETS,
]
export const adminActions = [
  ...CPT[EPM.ADMIN_DASHBOARD].modified,
  ...CPT[EPM.ADMIN_STATS].modified,
  ...CPT[EPM.ADMIN_BI].modified,
  ...CPT[EPM.ADMIN_LOGS].modified,
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_PERMISSION].modified,
  ...CPT[EPM.ADMIN_PARTNERS].modified,
  ...CPT[EPM.ADMIN_DOMAIN].modified,
  ...CPT[EPM.ADMIN_FEED].modified,
  ...CPT[EPM.ADMIN_FEED_FLOW].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_AUDIENCE].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_RULES].modified,
  ...CPT[EPM.ADMIN_PAYMENT].modified,
  ...CPT[EPM.ADMIN_NEWSLETTER].modified,
  ...CPT[EPM.ADMIN_NEWSLETTER_ASSETS].modified,
  ...CPT[EPM.ADMIN_NEWSLETTER_TEMPLATE].modified,
  ...CPT[EPM.ADMIN_LOGIN_HISTORY].modified,
  ...CPT[EPM.ADMIN_PROFILE].modified,
  ...CPT[EPM.ADMIN_COUNTRY].modified,
  ...CPT[EPM.ADMIN_TICKETS].modified,
]
export const managerActions = [
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_PROFILE].modified,
]

export const commonModules = [EPM.SETTINGS]
export const commonActions = [...CPT[EPM.SETTINGS].modified]